import { ReactElement } from 'react';

import { Flex, StyleProps, Text } from '@bonusly/design-system';

import { DropdownOption, DropdownOptionProps } from '../../../components/common/dropdown/dropdown-option';

interface Props extends StyleProps, Pick<DropdownOptionProps, 'onClick'> {
	icon: ReactElement;
	text: string;
}

export const IconOption: React.FC<Props> = ({ icon, text, ...rest }: Props) => (
	<DropdownOption variant="floating" p={3} borderRadius="md" {...rest}>
		<Flex alignItems="center" color="text.default" fontSize="2xl">
			{icon}

			<Text as="span" display="inline-flex" fontWeight="medium" fontSize="md" ml={4}>
				{text}
			</Text>
		</Flex>
	</DropdownOption>
);
